module.exports = __webpack_public_path__ + "img/rw.e28b5d13.svg";